import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // Last resort. The boundary that matters day to day is inside Layout, around
  // the routes; this one only catches a failure in App itself — the auth
  // bootstrap or the theme — where there is no sidebar left to preserve. It
  // renders with MUI's default theme rather than ours, which is acceptable for
  // a case where the app never started.
  <ErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);
